import { useMemo } from "react";

import { SETTINGS_KEYS } from "@/constants/settings-keys";
import { SettingsDefinition, useSettings } from "@/providers/general/settings-provider";

export function useRemoteConfigInput<T extends boolean | string | number>(
    key: SETTINGS_KEYS,
    customSettings?: SettingsDefinition,
    customOnChange?: (key: SETTINGS_KEYS, value: T) => void
) {
    const { currentSettings, setValue } = useSettings();

    const settings = useMemo(() => {
        if (customSettings) {
            return customSettings;
        }

        return currentSettings;
    }, [customSettings, currentSettings]);

    const value = settings[key] as T;

    const handleChange = (key: SETTINGS_KEYS, value: T) => {
        if (customOnChange) {
            customOnChange(key, value);
        } else {
            setValue(key, value);
        }
    };

    return {
        value,
        onChange: (value: T) => {
            if (typeof value === "boolean") {
                handleChange(key, value);
            } else if (typeof value === "string") {
                handleChange(key, value);
            } else if (typeof value === "number") {
                handleChange(key, value);
            } else {
                throw new Error(`Invalid value type: ${typeof value}`);
            }
        },
    };
}
